<template>
  <div class="side-layout">
    <layout-side>
      <slot name="side"></slot>
    </layout-side>
    <div class="layout-content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
import LayoutSide from "./components/SideLayout/Side";

export default {
  components: {
    LayoutSide
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";

.side-layout {
  $margin: 15px;
  margin: $margin;
  display: flex;

  background: #f7f7f7;
  height: calc(100vh - #{$topMenuHeight} - #{$margin}* 2);

  .layout-content {
    flex: 1;
    height: 100%;
    background: #fff;
  }
}
</style>